import React, { memo } from 'react';
import type { Props as DynamicLinkProps } from 'Components/frameworks/dynamic-link/DynamicLink';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Title } from 'Components/frameworks/title/Title';
export type ProductHeaderProps = {
  className?: string;
  heading: {
    title: string;
    subtitle?: string;
  };
  isLinkDisabled?: boolean;
  link?: DynamicLinkProps;
  onClick?: () => unknown;
};
export const ProductHeader = memo<ProductHeaderProps>(function ProductHeader({
  className,
  heading = {},
  isLinkDisabled,
  link = {
    url: '',
  },
  onClick,
}: ProductHeaderProps) {
  const { title = '', subtitle = '' } = heading;
  return (
    <header className={className} data-testid="Product-Header">
      <DynamicLink
        className="flex min-w-0 flex-col-reverse"
        data-testid="ProductHeader-link"
        onClick={onClick}
        tagname="div"
        url={isLinkDisabled ? '' : link.url}
        {...(isLinkDisabled ? null : link)}
      >
        {!isLinkDisabled && (
          <div className="absolute inset-0" data-testid="ProductHeader-link-overlay" />
        )}
        <Title className="flex font-sans text-18 font-semibold" hasEllipsis hLevel={2} theme="none">
          {title}
        </Title>
        <Title
          className="flex font-sans text-14 font-semibold text-sienna"
          hasEllipsis
          hLevel={3}
          theme="none"
        >
          {subtitle}
        </Title>
      </DynamicLink>
    </header>
  );
});
